import { ImageManagementActionDTO } from 'business/models/Models';
import React from 'react';
import { getCurrentOperationType } from '../utils';
import { ActionOperationType, ActionOperationValue } from '../constants';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import { IStyle } from 'Styles';
import { useOnChangeAction, useOnDeleteAction } from '../hooks';

export interface ActionBannerProps {
  actions?: ImageManagementActionDTO[];
  selectedAction?: ImageManagementActionDTO;
  storageList?: any;
}

const ActionsBanner = (props: ActionBannerProps) => {
  const { actions, selectedAction, storageList } = props;

  const onChangeAction = useOnChangeAction();
  const onDeleteAction = useOnDeleteAction();

  return (
    <>
      {actions?.map((value, i) => (
        <div
          id={`actionsbanner-${value}-wrapper`}
          key={`actBanner${i}`}
          onClick={() => onChangeAction(value)}
          className={`flex justify-between m-1 ${
            value?.id === selectedAction?.id ? 'font-semibold' : 'font-normal'
          }`}
          style={styles.actionsBanner}
        >
          <div id="actionsbanner-label" className="flex w-11/12 mt-2 ml-2">
            <label id="actionsbanner-label-content">
              {`${getCurrentOperationType(value)} from 
                ${storageList?.find((str) => str.id === value?.sourceImageStoreId)?.value}
                  ${
                    getCurrentOperationType(value) !==
                    ActionOperationType[ActionOperationValue.Delete]
                      ? `to ${
                          storageList?.find((str) => str.id === value?.targetImageStoreId)
                            ?.value
                        }`
                      : ``
                  }
              `}
            </label>
          </div>
          <div
            id="actionsbanner-button-delete"
            className="flex w-1/12 gap-2 justify-center align-center"
          >
            {
              <RMCustomButton
                onClick={() => {
                  onDeleteAction(value?.id);
                }}
                iconProps={{ name: 'CrossRounded', fill: '#737373' }}
                iconClass={`border rounded-sm`}
              />
            }
          </div>
        </div>
      ))}
    </>
  );
};

const styles: IStyle = {
  actionsBanner: {
    backgroundColor: '#DEE2E6',
    fontSize: 'smaller',
    borderRadius: '20px',
  },
};

export default ActionsBanner;
